import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import { FC } from "react";
import components from "..";

interface SalifySectionWrapperDefaultProps {
  title?: {
    text: string | undefined;
    cssProps?: TypographyProps;
  };
  description?: {
    text: string | undefined;
    cssProps?: TypographyProps;
  };
  stackProps?: StackProps;
  component: any;
}

const SalifySectionWrapperDefault: FC<SalifySectionWrapperDefaultProps> = (props) => {
  const Component =
    (components as any)?.[props.component?.blockName]?.[props.component?.variant || "default"] ??
    null;

  return (
    <Stack spacing={{ mobile: 1, tablet: 2 }} {...props.stackProps}>
      {(props.title?.text || props.description?.text) && (
        <Stack spacing={1}>
          {props.title && (
            <Typography
              component="p"
              variant="h4"
              fontWeight={700}
              textAlign="center"
              color="primary"
              textTransform="uppercase"
              {...props.title?.cssProps}
            >
              {props.title.text}
            </Typography>
          )}

          {props.description?.text && (
            <Typography
              component="p"
              variant="body1"
              textAlign="center"
              color="rgb(125, 135, 156)"
              {...props.description?.cssProps}
            >
              {props.description.text}
            </Typography>
          )}
        </Stack>
      )}

      {Component ? (
        <Component {...props.component?.props} />
      ) : (
        <Typography color="red">
          Chưa hỗ trợ component với block name: {props.component?.blockName}
        </Typography>
      )}
    </Stack>
  );
};

SalifySectionWrapperDefault.displayName = "SalifySectionWrapperDefault";

export default SalifySectionWrapperDefault;
